module.exports = __webpack_public_path__ + "static/security-2c2002d811548b0c786bc456b4f80ce2.svg";